import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-part-type-item',
    imports: [CommonModule, RouterLink],
    template: `
        <div class="category-item">
            <div class="picture">
                <a [routerLink]="model.path" title="Show products in part type {{ model.name }}">
                    <ng-template [ngTemplateOutlet]="partTypePicture"></ng-template>
                </a>
            </div>
        </div>
        <h2 class="title">
            <a [routerLink]="model.path" title="Show products in part type {{ model.name }}">{{ model.name }}</a>
        </h2>

        <ng-template #partTypePicture>
            <img
                src="{{ model.imageUrl }}"
                alt="Picture for part type {{ model.name }}"
                title="Show products in part type {{ model.name }}"
            />
        </ng-template>
    `,
    styles: `
        .title {
            position: relative;
        }
    `
})
export class PartTypeItemComponent {
    @Input() model!: PartTypeItemModel;
}

export class PartTypeItemModel {
    id!: string;
    name!: string;
    imageUrl!: string;
    path!: string;
}
